export enum CacheKeys {
    TUTOR_FINISHED = 'TUTOR_FINISHED',
    YM_NOT_LOADED = 'YM_NOT_LOADED',
    GA_NOT_LOADED = 'GA_NOT_LOADED',
    COOKIE_AGREEMENT_SET = 'COOKIE_AGREEMENT_SET',
    USER_EMAIL_ADDRESS = 'USER_EMAIL_ADDRESS',
    PRELOADER_TYPE = 'PRELOADER_TYPE',
    VAT = 'VAT',
    FEE = 'FEE'
}
